/**
 * Tracking parameter utilities
 */

export default {
  init() {
    console.log('Initializing tracking parameter capture....');
    // Get tracking parameters from various sources
    const trackingParams = this.getStoredTrackingParams();

    if (trackingParams) {
      console.group('📊 Tracking Parameters (Persisted)');
      console.table(trackingParams);
      const landingPage = this.getCookie('tracking_landing_page');
      console.log('Landing Page:', landingPage ? decodeURIComponent(landingPage.replace(/\+/g, ' ')) : 'Not recorded');
      console.log('First seen:', this.getCookie('tracking_timestamp') ? new Date(parseInt(this.getCookie('tracking_timestamp')) * 1000).toLocaleString() : 'Unknown');
      console.groupEnd();

    }

    // Check for NEW parameters in current URL
    const newParams = this.parseCurrentUrl();
    if (newParams && Object.keys(newParams).length > 0) {
      const mergedParams = {
        ...(trackingParams || {}),
        ...newParams,
      };

      // Store merged parameters in cookies for persistence
      this.storeTrackingParams(mergedParams);

      console.group('🆕 New Tracking Parameters Captured');
      console.table(newParams);
      console.group('📦 Merged Tracking Parameters (Persisted)');
      console.table(mergedParams);
      console.groupEnd();
      console.groupEnd();
    }
  },

  /**
   * Get stored tracking parameters from cookies or window object
   */
  getStoredTrackingParams() {
    // First check window object (set by PHP)
    if (window.siteTrackingParams) {
      return window.siteTrackingParams;
    }

    // Then check cookies
    const cookieParams = this.getCookie('site_tracking_params');
    if (cookieParams) {
      try {
        // PHP's setcookie() url-encodes values (and uses '+' for spaces), so decode before parsing
        return JSON.parse(decodeURIComponent(cookieParams.replace(/\+/g, ' ')));
      } catch (e) {
        console.error('Error parsing tracking cookie:', e);
      }
    }

    return null;
  },

  /**
   * Store tracking parameters in cookies
   */
  storeTrackingParams(params) {
    // Store for 30 days
    const expires = new Date();
    expires.setDate(expires.getDate() + 30);

    // Encode the value so it round-trips safely through document.cookie/getCookie
    document.cookie = `site_tracking_params=${encodeURIComponent(JSON.stringify(params))};expires=${expires.toUTCString()};path=/`;
    document.cookie = `tracking_timestamp=${Math.floor(Date.now() / 1000)};expires=${expires.toUTCString()};path=/`;
    document.cookie = `tracking_landing_page=${encodeURIComponent(window.location.pathname + window.location.search)};expires=${expires.toUTCString()};path=/`;
  },

  /**
   * Get cookie value by name
   */
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  },

  /**
   * Parse current URL for tracking parameters
   */
  parseCurrentUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const trackingParams = {};

    // List of tracking parameters to look for
    const paramsToTrack = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_adgroup',
      'utm_term',
      'utm_content',
      'gad_source',
      'gad_campaignid',
      'gbraid',
      'gclid',
      'fbclid',
      'msclkid',
      'oai_source',
      'oai_campaign',
      'oai_adgroup',
      'oai_adid',
      'oai_oppref'
    ];

    paramsToTrack.forEach(param => {
      if (urlParams.has(param)) {
        trackingParams[param] = urlParams.get(param);
      }
    });

    return Object.keys(trackingParams).length > 0 ? trackingParams : null;
  },
};
